'use client';

import styled from 'styled-components';

import { RADIUS } from '~/common/layout-propertis/radius';

export const Container = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Label = styled.label`
  display: flex;
  align-items: center;
  user-select: none;
`;

export const CheckboxSquare = styled.div`
  width: 16px;
  height: 16px;
  border-radius: ${RADIUS._4};
  border: ${({ theme }) => `1.5px solid ${theme.neutral[700]}`};
  transition: all 0.2s ease-out;
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    border: ${({ theme }) => `1.5px solid ${theme.neutral[600]}`};
  }
`;

export const CustomInput = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;

  &:focus + ${CheckboxSquare} {
    border-color: ${({ theme }) => theme.green[500]};

    &:checked {
      border-color: ${({ theme }) => theme.green[700]};
      background-color: ${({ theme }) => theme.green[700]};
    }
  }

  &:checked + ${CheckboxSquare} {
    background-color: ${({ theme }) => theme.green[500]};
    border-color: ${({ theme }) => theme.green[500]};

    &:hover {
      border-color: ${({ theme }) => theme.green[700]};
      background-color: ${({ theme }) => theme.green[700]};
    }
  }

  &:disabled + ${CheckboxSquare} {
    border-color: ${({ theme }) => theme.neutral[700]};
    background-color: ${({ theme }) => theme.neutral[700]};
    cursor: not-allowed;

    &:hover {
      border-color: ${({ theme }) => theme.neutral[700]};
    }
  }

  &:disabled:checked + ${CheckboxSquare} {
    border-color: ${({ theme }) => theme.neutral[700]};
    background-color: ${({ theme }) => theme.neutral[700]};
  }
`;
